import { useState } from "react";
import { notification } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import deliveryServiceTypes from "../../../constants/deliveryServiceTypes";
import useStore from "../../../hooks/useStore";
import GrubHubNotice from "./GrubHubNotice";
import GrubHubOnBoardingForm from "./GrubHubOnBoardingForm";
import GrubHubOnboarding from "./GrubhubOnboarding";
import DeliverySettings from "../deliverySettings/DeliverySettings";

export default function GrubHubDS() {
  const { store } = useStore();
  const deliverySetting = store?.deliverySettings?.grubhub;
  const [showForm, setShowForm] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showNotice, setShowNotice] = useState(false);

  const handleBack = () => {
    setShowNotice(false);
    setShowOptions(false);
    setShowForm(false);
  };

  const handleShowForm = () => {
    setShowForm(true);
    setShowOptions(false);
    setShowNotice(false);
  };

  const handleShowNotice = () => {
    setShowNotice(true);
    setShowOptions(false);
    setShowForm(false);
  };

  const openNotification = () => {
    notification.open({
      message: <strong>{`Grubhub Request Submitted`}</strong>,
      description: `Your form has been successfully submitted.`,
      placement: "top",
      icon: <CheckCircleFilled style={{ color: "#52c41a" }} />,
    });
  };

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    !showForm &&
    !showOptions &&
    !showNotice
  ) {
    return (
      <GrubHubOnboarding handleShowNotice={handleShowNotice} />
    );
  }

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    !showForm &&
    !showOptions &&
    showNotice
  ) {
    return <GrubHubNotice
      handleShowForm={handleShowForm}
      handleBack={handleBack}
      handleNotification={openNotification}
    />;
  }

  if (
    (!deliverySetting || Object.keys(deliverySetting).length === 0) &&
    showForm &&
    !showOptions
  ) {
    return <GrubHubOnBoardingForm
      closeForm={handleBack}
      handleNotification={openNotification}
    />;
  }

  return (
    <DeliverySettings deliveryService={deliveryServiceTypes.grubhub.cammel} />
  );
}
